export enum ExchangeDnCreationUponEnum {
  RETURN_CONFIRMATION = 'return_confirmation',
  OPENED_AUTHORIZATION = 'opened_authorization',
}
